import React, { Fragment } from "react";
import { Box, IconButton } from "@material-ui/core";
import { Favorite, ThumbUpAlt, Reply } from "@material-ui/icons";
import { useStyles } from "./styles";
import { get } from "lodash";
import { getUserId } from "src/utils";
import { LoadingWidget } from "Components/index";

const Reaction = ({
  reactionComment,
  parentComment,
  comments,
  setValue,
  loading,
  replyComment,
  visionCreator,
}) => {
  const classes = useStyles();
  const userId = getUserId();
  return (
    <Fragment>
      {userId !== visionCreator ? (
        ""
      ) : (
        <Box className={classes.root} display="flex">
          {get(loading, "Like", false) ? (
            <LoadingWidget color="grey" />
          ) : (
            <IconButton
              aria-label="like"
              size="small"
              data-testid="like"
              onClick={() =>
                reactionComment({
                  data: parentComment,
                  reaction: "Like",
                  listOfComments: comments,
                  setValue,
                })
              }
              className={classes.likeIcon}
            >
              <ThumbUpAlt fontSize="small" />
            </IconButton>
          )}
          {get(loading, "Love", false) ? (
            <LoadingWidget color="grey" />
          ) : (
            <IconButton
              aria-label="love"
              size="small"
              data-testid="love"
              onClick={() =>
                reactionComment({
                  data: parentComment,
                  reaction: "Love",
                  listOfComments: comments,
                  setValue,
                })
              }
              className={classes.loveIcon}
            >
              <Favorite fontSize="small" />
            </IconButton>
          )}
          <IconButton
            data-testid="reply"
            onClick={replyComment}
            aria-label="reply"
            size="small"
            className={classes.replyIcon}
          >
            <Reply fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Fragment>
  );
};

export default Reaction;
